module.exports = {"id":"217710","name":"Martín Barragán","rating":"71","photo":"./data/images/photos/0/217710.png","club":{"name":"Necaxa","logo":"./data/images/clubs/Necaxa.png"},"positions":["BU","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MartinBarragan0.json
// module id = 2811
// module chunks = 0